<template>
  <svg
    id="milestone-drop"
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="430"
    height="335"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 293.4 236.3"
    role="presentation"
    aria-labelledby="launchofdrop"
  >
    <title id="launchofdrop">Launch of Netlify Drop</title>
    <path
      class="cls-1"
      d="M202,83.6l1,65.3a6.8,6.8,0,0,0,2.9,5.3l84.3,49.6a2.9,2.9,0,0,0,3.4-1.2,3.2,3.2,0,0,0,.3-1.4V135.6a6.6,6.6,0,0,0-2.7-5L205.6,81.4C204.4,80.5,202,81.6,202,83.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M202,83.8v65.6a6.9,6.9,0,0,0,2.9,5.3l85.2,49a1.7,1.7,0,0,0,2.5-.6,3.2,3.2,0,0,0,.3-1.4V136.1a6.3,6.3,0,0,0-2.7-5L204.6,81.8C203.3,81.1,202,81.8,202,83.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M207.5,89.2v59.4l10.3,6,16.8,9.7L288.1,195V135.6l-33.2-19.1-15.2-8.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-3"
      d="M246.5,109c0-.6.4-.9,1-.6a2.3,2.3,0,0,1,1,1.7c0,.6-.4,1-1,.6A2.2,2.2,0,0,1,246.5,109Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-4"
      d="M242.1,176.1l48.1,27.7a1.7,1.7,0,0,0,2.6-.6,5.9,5.9,0,0,0,.2-1.4V136.2a6.3,6.3,0,0,0-2.7-5l-.8-.5-22.4-12.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M203.4,153.7,290.8,202c1,.6.9,3.4-.2,4l-52.4,30.1a4,4,0,0,1-3.7,0l-87.2-50.2c-.9-.6-1.3-3.4-.2-4l52.7-28.3A4.1,4.1,0,0,1,203.4,153.7Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M203.4,151.6l87.2,50.2c.9.7.9,1.6,0,2.1L238.2,234a3.5,3.5,0,0,1-3.7,0l-87.2-50.2c-.9-.6-.9-1.6,0-2l52.5-30.2A3.8,3.8,0,0,1,203.4,151.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M197.6,191.7,221,205.1a1.1,1.1,0,0,1,0,1.9l-13.3,7.6a3.6,3.6,0,0,1-3.2,0l-23.4-13.5a1,1,0,0,1,0-1.8l13.2-7.6A3.8,3.8,0,0,1,197.6,191.7Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M204.5,154l82.9,47.6c1.2.7,1.2,1.8,0,2.4l-30.8,17.7a4.7,4.7,0,0,1-4.3,0L169.5,174c-1.3-.7-1.3-1.8,0-2.4L200.2,154A4.2,4.2,0,0,1,204.5,154Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M274.7,204.5a.4.4,0,0,1,0-.8l3.3-2a2,2,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,2a1.9,1.9,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M272.1,203.1l-3.3-2c-.4-.2-.4-.6,0-.9l3.3-1.9a1.4,1.4,0,0,1,1.5,0l3.3,1.9c.4.3.4.7,0,.9l-3.3,2A2,2,0,0,1,272.1,203.1Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M266.2,199.6l-3.3-1.9q-.6-.4,0-.9l3.3-1.9a1.4,1.4,0,0,1,1.5,0l3.3,1.9q.6.4,0,.9l-3.3,1.9A1.4,1.4,0,0,1,266.2,199.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M260.3,196.2l-3.3-2a.4.4,0,0,1,0-.8l3.3-2a2,2,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,2A1.4,1.4,0,0,1,260.3,196.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M254.4,192.9l-3.3-2a.4.4,0,0,1,0-.8l3.3-2a2,2,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M248.5,189.5l-3.3-2a.4.4,0,0,1,0-.8l3.3-2a2,2,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,2A1.9,1.9,0,0,1,248.5,189.5Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M244.1,186a1.4,1.4,0,0,1-1.5,0l-3.3-1.9q-.6-.4,0-.9l3.3-1.9a1.4,1.4,0,0,1,1.5,0l3.3,1.9q.6.5,0,.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M241.5,180.8l-3.3,1.9a1.4,1.4,0,0,1-1.5,0l-3.3-1.9q-.6-.5,0-.9l3.3-1.9a1.4,1.4,0,0,1,1.5,0l3.3,1.9Q242.1,180.3,241.5,180.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M235.6,177.4l-3.3,1.9a1.4,1.4,0,0,1-1.5,0l-3.3-1.9c-.4-.3-.4-.7,0-.9l3.3-2a2,2,0,0,1,1.5,0l3.3,2C236,176.7,236,177.1,235.6,177.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M226.4,171.2l3.3,2a.4.4,0,0,1,0,.8l-3.3,2a1.4,1.4,0,0,1-1.5,0l-3.3-2a.4.4,0,0,1,0-.8l3.3-2A1.9,1.9,0,0,1,226.4,171.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M215.7,170.6a.4.4,0,0,1,0-.8l3.3-2a1.9,1.9,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,2a1.9,1.9,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M209.8,167.2q-.6-.4,0-.9l3.3-1.9a1.4,1.4,0,0,1,1.5,0l3.3,1.9q.6.4,0,.9l-3.3,1.9a1.4,1.4,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M203.9,163.8c-.4-.3-.4-.7,0-.9l3.3-2a2,2,0,0,1,1.5,0l3.3,2c.4.2.4.6,0,.9l-3.3,1.9a1.4,1.4,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M198.7,156.2a1.4,1.4,0,0,1,1.5,0l6.1,3.5q.6.5,0,.9l-3.3,1.9a1.2,1.2,0,0,1-1.4,0l-6.2-3.5q-.6-.5,0-.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M284.3,203.3l-4.3-2.4c-.3-.2-.3-.3,0-.4l1-.6h.7l4.3,2.4c.3.2.3.3,0,.4l-1,.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M278.1,199.8l-4.3-2.5c-.2-.1-.2-.2,0-.4l1-.6a1.1,1.1,0,0,1,.8,0l4.3,2.5q.3.1,0,.3l-1,.7Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M272.1,196.2l-4.3-2.4c-.2-.2-.2-.3,0-.4l1-.6a.9.9,0,0,1,.7,0l4.3,2.4c.3.2.3.3,0,.4l-.9.6A1.1,1.1,0,0,1,272.1,196.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M266,192.7l-4.3-2.5c-.3-.1-.3-.2,0-.4l.9-.6h.8l4.3,2.5q.3.2,0,.3l-1,.7A.8.8,0,0,1,266,192.7Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M259.8,189.2l-4.3-2.4a.2.2,0,0,1,0-.4l1-.6a.9.9,0,0,1,.7,0l4.3,2.4c.3.2.3.3,0,.4l-.9.6A.6.6,0,0,1,259.8,189.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M253.7,185.7l-4.3-2.5q-.5-.1,0-.3l1-.6c.2-.2.4-.2.7,0l4.3,2.4c.2.1.2.2,0,.4l-1,.6A.8.8,0,0,1,253.7,185.7Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M247.7,182.1l-4.4-2.4a.2.2,0,0,1,0-.4l1-.6h.8l4.3,2.4c.2.2.2.3,0,.4l-1,.6C248.1,182.3,247.8,182.3,247.7,182.1Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M241.5,178.7l-4.3-2.4c-.2-.2-.2-.3,0-.4l1-.6a.5.5,0,0,1,.7,0l4.3,2.4c.3.1.3.3,0,.4l-1,.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M235.4,175.1l-4.3-2.4c-.3-.1-.3-.2,0-.4l.9-.6h.8l4.3,2.5q.3.2,0,.3l-1,.6A.5.5,0,0,1,235.4,175.1Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M229.2,171.6l-4.3-2.5q-.3-.2,0-.3l1-.6a.5.5,0,0,1,.7,0l4.3,2.4c.3.1.3.3,0,.4l-1,.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M223.1,168l-4.3-2.4c-.3-.1-.3-.2,0-.4l.9-.6h.8l4.3,2.5q.3.2,0,.3l-1,.6C223.7,168.2,223.3,168.2,223.1,168Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M217,164.6l-4.3-2.4c-.2-.2-.2-.3,0-.4l1-.6h.8l4.3,2.4c.2.2.2.3,0,.4l-1,.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M210.9,161.1l-4.3-2.5q-.4-.2,0-.3l1-.7h.7l4.3,2.5c.3.1.3.2,0,.4l-1,.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M205.2,157.8l-4.3-2.5c-.2-.1-.2-.2,0-.4l1-.6a1.1,1.1,0,0,1,.8,0l4.3,2.5q.3.1,0,.3l-1,.7Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M194.3,159.6l3.3,2a.4.4,0,0,1,0,.8l-3.3,1.9a2,2,0,0,1-1.5,0l-3.3-2q-.6-.5,0-.9l3.3-1.8A2,2,0,0,1,194.3,159.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M195.4,165.7a.4.4,0,0,1,0-.8l3.3-1.9a1.9,1.9,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,1.9a2,2,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M201.3,169.1a.4.4,0,0,1,0-.8l3.3-1.8a1.4,1.4,0,0,1,1.5,0l3.3,1.9q.6.4,0,.9l-3.3,1.8a1.4,1.4,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M207.2,172.5c-.4-.3-.4-.7,0-.9l3.3-1.8a1.4,1.4,0,0,1,1.5,0l3.3,1.9q.6.5,0,.9l-3.3,1.8a1.4,1.4,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M221.2,175.9l-3.3,1.8a1.4,1.4,0,0,1-1.5,0l-3.3-1.9c-.4-.3-.4-.7,0-.9l3.3-1.8a1.4,1.4,0,0,1,1.5,0l3.3,1.9Q222,175.5,221.2,175.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M227.1,179.3l-3.3,1.8a1.4,1.4,0,0,1-1.5,0l-3.3-1.9q-.6-.4,0-.9l3.3-1.8a2,2,0,0,1,1.5,0l3.3,2C227.6,178.7,227.6,179.1,227.1,179.3Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M224.9,182.7a.4.4,0,0,1,0-.8l3.3-1.9a2,2,0,0,1,1.5,0l3.3,2c.4.2.4.6,0,.9l-3.3,1.8a2,2,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M230.8,186a.4.4,0,0,1,0-.8l3.3-1.8a1.4,1.4,0,0,1,1.5,0l3.3,1.9q.6.4,0,.9l-3.3,1.8a1.9,1.9,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M236.7,189.5q-.6-.5,0-.9l3.3-1.8a1.4,1.4,0,0,1,1.5,0l3.3,1.9c.4.3.4.7,0,.9l-3.3,1.8a1.4,1.4,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M242.6,192.9c-.4-.2-.4-.6,0-.9l3.3-1.8a2,2,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,1.9a2,2,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M248.5,196.2a.4.4,0,0,1,0-.8l3.3-1.9a1.9,1.9,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,1.9a1.9,1.9,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M254.4,199.6a.4.4,0,0,1,0-.8l3.3-1.9a2,2,0,0,1,1.5,0l3.3,2c.4.2.4.6,0,.9l-3.3,1.8a1.9,1.9,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M260.3,202.2l3.3-1.8a1.4,1.4,0,0,1,1.5,0l3.3,1.9q.6.4,0,.9l-3.3,1.8a1.4,1.4,0,0,1-1.5,0l-3.3-1.9Q259.7,202.7,260.3,202.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M273.6,209.8a2,2,0,0,1-1.5,0l-6-3.6a.4.4,0,0,1,0-.8l3.3-1.8a1.4,1.4,0,0,1,1.5,0l6,3.5q.6.5,0,.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M197.4,173.7l-3.3-2a.4.4,0,0,1,0-.8l3.3-2a1.7,1.7,0,0,1,1.4,0l3.4,2a.5.5,0,0,1,0,.8l-3.4,2A2.2,2.2,0,0,1,197.4,173.7Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M203,176.9l-3.3-2c-.4-.2-.4-.6,0-.9l3.3-1.9a1.4,1.4,0,0,1,1.5,0l3.3,1.9c.4.3.4.7,0,.9l-3.3,2A1.9,1.9,0,0,1,203,176.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M205.6,177.5l3.3-2a1.9,1.9,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,2a1.9,1.9,0,0,1-1.5,0l-3.3-2C205.1,178.1,205.1,177.7,205.6,177.5Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M211.5,180.9l3.3-2a2,2,0,0,1,1.5,0l3.3,2c.4.2.4.6,0,.9l-3.3,1.9a1.4,1.4,0,0,1-1.5,0l-3.3-1.9C211,181.5,211,181.1,211.5,180.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M217.4,184.2l3.3-1.9a1.4,1.4,0,0,1,1.5,0l3.3,1.9q.6.5,0,.9l-3.3,1.9a1.4,1.4,0,0,1-1.5,0l-3.3-1.9Q216.7,184.7,217.4,184.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M223.3,187.6l3.3-1.9a1.4,1.4,0,0,1,1.5,0l3.3,1.9q.6.5,0,.9l-3.3,2a1.9,1.9,0,0,1-1.5,0l-3.3-2C222.9,188.2,222.8,187.9,223.3,187.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M229.2,191.1l3.3-2a2,2,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,2a1.9,1.9,0,0,1-1.5,0l-3.3-2A.4.4,0,0,1,229.2,191.1Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M235.1,194.5l3.3-2a1.9,1.9,0,0,1,1.5,0l3.3,2c.4.2.4.6,0,.9l-3.3,1.9a1.4,1.4,0,0,1-1.5,0l-3.3-1.9C234.7,195.1,234.7,194.6,235.1,194.5Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M244.3,200.6l-3.3-1.9c-.4-.3-.4-.7,0-.9l3.3-2a1.9,1.9,0,0,1,1.5,0l3.3,2c.4.2.4.6,0,.9l-3.3,1.9A1.4,1.4,0,0,1,244.3,200.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M250.2,204l-3.3-1.9q-.6-.4,0-.9l3.3-1.9a1.4,1.4,0,0,1,1.5,0l3.3,1.9q.6.5,0,.9l-3.3,1.9A1.4,1.4,0,0,1,250.2,204Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M256.1,207.4l-3.3-2q-.6-.5,0-.9l3.3-1.9a1.4,1.4,0,0,1,1.5,0l3.3,1.9q.6.5,0,.9l-3.3,2A2,2,0,0,1,256.1,207.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M266.3,213.2l-7.7-4.5c-.4-.2-.4-.6,0-.9l3.3-1.9a1.4,1.4,0,0,1,1.5,0l7.7,4.5q.6.4,0,.9l-3.3,1.9A1.4,1.4,0,0,1,266.3,213.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M191.3,170.1l-7.7-4.5c-.4-.2-.4-.6,0-.9l3.3-1.9a1.4,1.4,0,0,1,1.5,0l7.7,4.5q.6.4,0,.9l-3.3,1.9A1.4,1.4,0,0,1,191.3,170.1Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M195.6,173.8l3.1,1.7c.5.3.5.8,0,1l-3.1,1.7a1.7,1.7,0,0,1-1.7,0l-3-1.7c-.5-.2-.5-.7,0-1l3-1.7A2.5,2.5,0,0,1,195.6,173.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M201.6,177.2l3,1.7c.5.3.5.8,0,1l-3,1.7a1.9,1.9,0,0,1-1.8,0l-3-1.7c-.5-.2-.5-.7,0-1l3-1.7A2.8,2.8,0,0,1,201.6,177.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M205.7,185.2l-3-1.7c-.5-.3-.5-.8,0-1l3-1.7a1.9,1.9,0,0,1,1.8,0l3,1.7c.5.2.5.7,0,1l-3,1.7A2.8,2.8,0,0,1,205.7,185.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M211.6,188.6l-3-1.7c-.5-.2-.5-.7,0-1l3-1.7a2.8,2.8,0,0,1,1.8,0l3,1.7c.5.3.5.8,0,1l-3,1.7A1.9,1.9,0,0,1,211.6,188.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M217.5,191.9l-3-1.7c-.5-.2-.5-.7,0-1l3-1.7a2.8,2.8,0,0,1,1.8,0l3,1.7c.5.3.5.8,0,1l-3,1.7A1.5,1.5,0,0,1,217.5,191.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M223.4,195.4l-3-1.8c-.5-.2-.5-.7,0-.9l3-1.8a2.8,2.8,0,0,1,1.8,0l3,1.8c.5.2.5.7,0,.9l-3,1.8A2.8,2.8,0,0,1,223.4,195.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M229.3,198.8l-3-1.7c-.5-.3-.5-.8,0-1l3-1.7a1.9,1.9,0,0,1,1.8,0l3,1.7c.5.2.5.7,0,1l-3,1.7A2.8,2.8,0,0,1,229.3,198.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M235.2,202.1l-3-1.7c-.5-.3-.5-.8,0-1l3-1.7a1.9,1.9,0,0,1,1.8,0l3,1.7c.5.2.5.7,0,1l-3,1.7A1.5,1.5,0,0,1,235.2,202.1Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M242.9,201l3,1.7c.5.2.5.7,0,1l-3,1.7a2.8,2.8,0,0,1-1.8,0l-3-1.7c-.5-.3-.5-.8,0-1l3-1.7A1.9,1.9,0,0,1,242.9,201Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M244,206.1l3-1.7a2.8,2.8,0,0,1,1.8,0l3,1.7c.5.3.5.8,0,1l-3,1.7a1.9,1.9,0,0,1-1.8,0l-3-1.7C243.5,206.9,243.5,206.5,244,206.1Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M250.1,209.7l3.1-1.7a1.7,1.7,0,0,1,1.7,0l10.3,5.8c.5.3.5.8,0,1l-3,1.7a1.9,1.9,0,0,1-1.8,0l-10.3-5.8C249.6,210.4,249.6,209.9,250.1,209.7Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M182.5,166.3l10.3,5.9c.5.3.5.7,0,1l-3.1,1.7a2.5,2.5,0,0,1-1.7,0L177.7,169c-.5-.2-.5-.7,0-1l3.1-1.7A2.5,2.5,0,0,1,182.5,166.3Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M190.1,178l3.3,1.9q.6.4,0,.9l-3.3,1.9a1.4,1.4,0,0,1-1.5,0l-3.3-1.9a.6.6,0,0,1,0-.9l3.3-1.9A1.4,1.4,0,0,1,190.1,178Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M182,176.6l2.2,1.4a.4.4,0,0,1,0,.8l-.4.3a1.7,1.7,0,0,1-1.4,0l-2.2-1.4a.4.4,0,0,1,0-.8l.3-.3A1.9,1.9,0,0,1,182,176.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M177.7,174.2l2.2,1.3q.6.5,0,.9l-.4.2a1.2,1.2,0,0,1-1.4,0l-2.2-1.3q-.6-.5,0-.9l.3-.2A1.4,1.4,0,0,1,177.7,174.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M173.2,171.6l2.2,1.3a.6.6,0,0,1,0,.9l-.4.2a1.4,1.4,0,0,1-1.5,0l-2.2-1.3c-.4-.2-.4-.6,0-.9l.4-.2A1.9,1.9,0,0,1,173.2,171.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M180.4,172.6l2.2,1.3q.6.4,0,.9l-.4.2a1.2,1.2,0,0,1-1.4,0l-2.2-1.3q-.6-.4,0-.9l.3-.2A1.4,1.4,0,0,1,180.4,172.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M236.7,204.8l4.9,2.8c.4.2.4.6,0,.9l-3.3,1.9a1.4,1.4,0,0,1-1.5,0l-4.9-2.8c-.4-.2-.4-.6,0-.9l3.3-1.9A1.4,1.4,0,0,1,236.7,204.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M195.8,181.3l4.9,2.8a.4.4,0,0,1,0,.8l-3.3,2a1.9,1.9,0,0,1-1.5,0l-4.9-2.8q-.6-.4,0-.9l3.3-1.9A1.4,1.4,0,0,1,195.8,181.3Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M244,208.9l3.3,2c.4.2.4.6,0,.9l-3.3,1.9a1.4,1.4,0,0,1-1.5,0l-3.3-1.9c-.4-.3-.4-.7,0-.9l3.3-2A2,2,0,0,1,244,208.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M249.9,212.4l3.3,1.9q.6.4,0,.9l-3.3,1.9a1.4,1.4,0,0,1-1.5,0l-3.3-1.9q-.6-.4,0-.9l3.3-1.9A1.4,1.4,0,0,1,249.9,212.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M255.6,215.7l3.4,1.9a.6.6,0,0,1,0,.9l-3.4,2a1.7,1.7,0,0,1-1.4,0l-3.4-2a.6.6,0,0,1,0-.9l3.4-1.9A1.2,1.2,0,0,1,255.6,215.7Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M203,185.3l31.4,18a.6.6,0,0,1,0,.9l-3.3,1.9a1.4,1.4,0,0,1-1.5,0l-31.4-18a.5.5,0,0,1,0-.8l3.4-2A1.7,1.7,0,0,1,203,185.3Z"
      transform="translate(-1 -0.7)"
    />
    <path class="cls-1" d="M281.8,210.7l5.1-3v-1.1l-5.1,3Z" transform="translate(-1 -0.7)" />
    <path class="cls-1" d="M274.3,215.1l5.1-3V211l-5.1,3Z" transform="translate(-1 -0.7)" />
    <path
      class="cls-1"
      d="M57.2,3.7l1,65.4A7.2,7.2,0,0,0,61,74.4L145.4,124c1.1.6,2.9-.3,3.4-1.3a4.2,4.2,0,0,0,.3-1.3V55.8a6.8,6.8,0,0,0-2.7-5.1L60.9,1.5A2.6,2.6,0,0,0,57.2,3.7Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M57.2,4V69.6A7.2,7.2,0,0,0,60,74.9l85.2,48.9c1.2.7,2.1.4,2.6-.6a4.2,4.2,0,0,0,.3-1.3V56.3a6.8,6.8,0,0,0-2.7-5.1L59.9,2.1C58.5,1.3,57.2,2,57.2,4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M62.6,9.4V68.7l10.4,6,16.8,9.7,53.5,30.8V55.8L110.1,36.7,94.7,28Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-3"
      d="M101.7,29.2c0-.6.4-1,1-.6a2.2,2.2,0,0,1,1,1.7c0,.6-.4,1-1,.6A2,2,0,0,1,101.7,29.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-4"
      d="M97.2,96.3l48,27.7a1.8,1.8,0,0,0,2.6-.6,5.8,5.8,0,0,0,.3-1.4V56.3a6.8,6.8,0,0,0-2.7-5.1l-.9-.5L122.3,37.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M58.6,73.9,146,122.1c1,.6.8,3.5-.3,4.1L93.2,156.3a3.8,3.8,0,0,1-3.6,0L2.4,106.1c-1-.6-1.4-3.4-.3-4L54.9,73.8A4.4,4.4,0,0,1,58.6,73.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M58.6,71.8,145.7,122c1,.6,1,1.6,0,2.1L93.2,154.2a3.8,3.8,0,0,1-3.6,0L2.4,104c-1-.6-1-1.6,0-2.1L54.9,71.8A4,4,0,0,1,58.6,71.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M52.7,112,76,125.4a1,1,0,0,1,0,1.9l-13.1,7.6a3.6,3.6,0,0,1-3.2,0L36.3,121.4a1,1,0,0,1,0-1.8L49.5,112A3.1,3.1,0,0,1,52.7,112Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M59.7,74.1l82.8,47.7c1.3.7,1.3,1.8,0,2.4l-30.7,17.6a4.2,4.2,0,0,1-4.3,0L24.6,94.2c-1.2-.7-1.2-1.8,0-2.4L55.4,74.1A4.7,4.7,0,0,1,59.7,74.1Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M129.8,124.7c-.4-.2-.4-.6,0-.9l3.3-1.9a1.2,1.2,0,0,1,1.4,0l3.4,1.9a.6.6,0,0,1,0,.9l-3.4,2a1.7,1.7,0,0,1-1.4,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M127.3,123.2l-3.3-1.9q-.6-.5,0-.9l3.3-1.9a1.4,1.4,0,0,1,1.5,0l3.3,1.9q.6.4,0,.9l-3.3,1.9A1.4,1.4,0,0,1,127.3,123.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M121.4,119.8l-3.3-2a.4.4,0,0,1,0-.8l3.3-2a2,2,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,2A1.4,1.4,0,0,1,121.4,119.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M115.4,116.4l-3.3-1.9a.4.4,0,0,1,0-.8l3.3-2a1.7,1.7,0,0,1,1.4,0l3.4,2a.5.5,0,0,1,0,.8l-3.4,2A2.3,2.3,0,0,1,115.4,116.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M109.5,113.1l-3.3-2a.4.4,0,0,1,0-.8l3.3-2a1.7,1.7,0,0,1,1.4,0l3.4,2a.5.5,0,0,1,0,.8l-3.4,2A1.7,1.7,0,0,1,109.5,113.1Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M103.6,109.6l-3.4-1.9a.6.6,0,0,1,0-.9l3.4-1.9a1.2,1.2,0,0,1,1.4,0l3.4,1.9a.6.6,0,0,1,0,.9l-3.4,1.9A1.2,1.2,0,0,1,103.6,109.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M99.1,106.2a1.2,1.2,0,0,1-1.4,0l-3.4-1.8a.6.6,0,0,1,0-.9l3.4-1.9a1.2,1.2,0,0,1,1.4,0l3.4,1.9a.6.6,0,0,1,0,.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M96.6,100.9l-3.4,2a1.2,1.2,0,0,1-1.4,0l-3.4-2a.5.5,0,0,1,0-.8l3.4-2a1.7,1.7,0,0,1,1.4,0l3.4,2C97.1,100.3,97.1,100.7,96.6,100.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M90.7,97.5l-3.4,2a1.7,1.7,0,0,1-1.4,0l-3.4-2a.5.5,0,0,1,0-.8l3.4-2a1.7,1.7,0,0,1,1.4,0l3.4,2C91.2,96.9,91.2,97.3,90.7,97.5Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M81.4,91.4l3.4,2a.5.5,0,0,1,0,.8l-3.4,2a1.7,1.7,0,0,1-1.4,0l-3.4-2a.5.5,0,0,1,0-.8l3.4-2A1.7,1.7,0,0,1,81.4,91.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M70.7,90.8a.6.6,0,0,1,0-.9L74.1,88a1.2,1.2,0,0,1,1.4,0l3.4,1.9a.6.6,0,0,1,0,.9l-3.4,1.9a1.2,1.2,0,0,1-1.4,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M64.8,87.4a.6.6,0,0,1,0-.9l3.4-2a1.7,1.7,0,0,1,1.4,0l3.4,2a.6.6,0,0,1,0,.9l-3.4,1.9a1.2,1.2,0,0,1-1.4,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M58.9,83.9a.5.5,0,0,1,0-.8l3.4-2a1.7,1.7,0,0,1,1.4,0l3.4,2a.5.5,0,0,1,0,.8l-3.4,2a1.7,1.7,0,0,1-1.4,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M53.9,76.3a1.9,1.9,0,0,1,1.5,0l6.1,3.6a.4.4,0,0,1,0,.8l-3.3,2a2,2,0,0,1-1.5,0l-6.1-3.5c-.4-.3-.4-.7,0-.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M139.5,123.5l-4.3-2.5q-.4-.1,0-.3l.9-.6a.6.6,0,0,1,.8,0l4.3,2.4c.2.1.2.2,0,.4l-1,.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M133.3,119.9l-4.3-2.4a.2.2,0,0,1,0-.4l1-.6h.7l4.3,2.4c.3.2.3.3,0,.4l-.9.6A.6.6,0,0,1,133.3,119.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M127.2,116.4l-4.3-2.5q-.5-.2,0-.3l1-.7a.8.8,0,0,1,.7,0l4.3,2.5c.2.1.2.2,0,.4l-1,.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M121,112.9l-4.3-2.4c-.2-.1-.2-.2,0-.4l1-.6h.7l4.3,2.5q.5.1,0,.3l-.9.6A.6.6,0,0,1,121,112.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M115,109.4l-4.3-2.5q-.3-.2,0-.3l1-.6a.5.5,0,0,1,.7,0l4.3,2.4c.3.1.3.3,0,.4l-1,.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M108.9,105.8l-4.3-2.4c-.3-.1-.3-.2,0-.4l.9-.6a1.1,1.1,0,0,1,.8,0l4.3,2.5q.3.1,0,.3l-1,.6C109.3,106,109.1,106,108.9,105.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M102.7,102.3l-4.3-2.5q-.3-.1,0-.3l1-.6a.5.5,0,0,1,.7,0l4.3,2.4c.3.1.3.3,0,.4l-1,.6A.8.8,0,0,1,102.7,102.3Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M96.6,98.9l-4.3-2.5q-.5-.2,0-.3l.9-.7a1.1,1.1,0,0,1,.8,0l4.3,2.5c.2.1.2.2,0,.4l-1,.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M90.5,95.3l-4.3-2.4c-.2-.2-.2-.3,0-.4l1-.6a1.1,1.1,0,0,1,.8,0l4.3,2.4c.2.2.2.3,0,.4l-1,.6A1.1,1.1,0,0,1,90.5,95.3Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M84.4,91.8l-4.3-2.5c-.3-.1-.3-.2,0-.4l1-.6h.7l4.3,2.5c.3.1.3.2,0,.4l-1,.6A.8.8,0,0,1,84.4,91.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M78.2,88.2l-4.3-2.4c-.2-.2-.2-.3,0-.4l1-.6h.8L80,87.2c.2.2.2.3,0,.4l-1,.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M72.1,84.8l-4.3-2.5q-.5-.1,0-.3l1-.6a.5.5,0,0,1,.7,0l4.3,2.4c.3.1.3.3,0,.4l-1,.6A.8.8,0,0,1,72.1,84.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M65.9,81.2l-4.3-2.4a.2.2,0,0,1,0-.4l1-.6h.8l4.3,2.5q.3.2,0,.3l-1,.6C66.6,81.4,66.2,81.4,65.9,81.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M60.3,77.9,56,75.5c-.3-.1-.3-.3,0-.4l1-.6h.7L62,76.9c.3.2.3.3,0,.4l-1,.6A.5.5,0,0,1,60.3,77.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M49.5,79.8l3.3,1.9q.6.5,0,.9l-3.3,1.8a1.4,1.4,0,0,1-1.5,0l-3.3-1.9c-.4-.3-.4-.7,0-.9L48,79.8A1.4,1.4,0,0,1,49.5,79.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M50.6,85.9q-.6-.5,0-.9l3.3-1.8a1.4,1.4,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,1.8a1.4,1.4,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M56.5,89.3a.4.4,0,0,1,0-.8l3.3-1.9a2,2,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,1.9a2,2,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M62.4,92.6a.4.4,0,0,1,0-.8l3.3-1.9a1.9,1.9,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,1.9a2,2,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M76.4,96.1l-3.3,1.8a1.9,1.9,0,0,1-1.5,0l-3.3-2a.4.4,0,0,1,0-.8l3.3-1.9a2,2,0,0,1,1.5,0l3.3,2C76.8,95.4,76.8,95.8,76.4,96.1Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M82.3,99.5,79,101.3a1.4,1.4,0,0,1-1.5,0l-3.3-1.9c-.4-.3-.4-.7,0-.9l3.3-1.8a1.4,1.4,0,0,1,1.5,0l3.3,1.9Q82.9,99.1,82.3,99.5Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M80.1,102.9a.4.4,0,0,1,0-.8l3.3-1.9a2,2,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,1.7a1.4,1.4,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M86,106.2a.4.4,0,0,1,0-.8l3.3-1.9a2,2,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,1.9a1.9,1.9,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M91.9,109.6a.4.4,0,0,1,0-.8l3.3-1.9a2,2,0,0,1,1.5,0l3.3,2q.6.4,0,.9l-3.3,1.8a1.9,1.9,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M97.8,113.1q-.6-.4,0-.9l3.3-1.8a1.4,1.4,0,0,1,1.5,0l3.3,1.9q.6.5,0,.9l-3.3,1.8a1.4,1.4,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M103.7,116.5c-.4-.2-.4-.6,0-.9l3.3-1.8a1.9,1.9,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,1.9a1.9,1.9,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M109.6,119.8c-.4-.2-.4-.6,0-.9l3.3-1.8a1.9,1.9,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,1.9a2,2,0,0,1-1.5,0Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M115.5,122.4l3.3-1.9a2,2,0,0,1,1.5,0l3.3,2c.4.2.4.6,0,.9l-3.3,1.8a1.9,1.9,0,0,1-1.5,0l-3.3-2A.4.4,0,0,1,115.5,122.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M128.8,130a2,2,0,0,1-1.5,0l-6-3.6a.4.4,0,0,1,0-.8l3.3-1.9a1.9,1.9,0,0,1,1.5,0l6,3.6a.4.4,0,0,1,0,.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M52.5,93.8l-3.3-1.9a.6.6,0,0,1,0-.9l3.3-1.9a1.4,1.4,0,0,1,1.5,0L57.3,91q.6.4,0,.9L54,93.8A1.4,1.4,0,0,1,52.5,93.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M58.1,97l-3.3-1.9q-.6-.4,0-.9l3.3-1.9a1.4,1.4,0,0,1,1.5,0l3.3,1.9a.6.6,0,0,1,0,.9L59.6,97A1.4,1.4,0,0,1,58.1,97Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M60.7,97.6,64,95.7a1.4,1.4,0,0,1,1.5,0l3.3,1.9a.6.6,0,0,1,0,.9l-3.3,2a2,2,0,0,1-1.5,0l-3.3-2C60.3,98.3,60.3,97.9,60.7,97.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M66.6,101.1l3.3-2a1.9,1.9,0,0,1,1.5,0l3.3,2a.5.5,0,0,1,0,.8l-3.3,2a2,2,0,0,1-1.5,0l-3.3-2A.4.4,0,0,1,66.6,101.1Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M72.5,104.5l3.3-2a1.9,1.9,0,0,1,1.5,0l3.3,2a.6.6,0,0,1,0,.9l-3.2,1.8a2,2,0,0,1-1.5,0l-3.3-2C72.1,105.1,72.1,104.6,72.5,104.5Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M78.4,107.8l3.3-2a1.9,1.9,0,0,1,1.5,0l3.3,2a.6.6,0,0,1,0,.9l-3.2,1.9a1.4,1.4,0,0,1-1.5,0l-3.4-1.9Q77.8,108.3,78.4,107.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M84.3,111.2l3.3-1.9a1.4,1.4,0,0,1,1.5,0l3.3,1.9a.6.6,0,0,1,0,.9l-3.3,2a1.9,1.9,0,0,1-1.5,0l-3.3-2Q83.7,111.7,84.3,111.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M90.2,114.7l3.3-2a2,2,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,2a1.9,1.9,0,0,1-1.5,0l-3.3-2A.4.4,0,0,1,90.2,114.7Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M99.5,120.8l-3.3-2a.4.4,0,0,1,0-.8l3.3-2a2,2,0,0,1,1.5,0l3.3,2a.4.4,0,0,1,0,.8l-3.3,2A1.9,1.9,0,0,1,99.5,120.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M105.4,124.2l-3.3-1.9c-.4-.3-.4-.7,0-.9l3.3-2a2,2,0,0,1,1.5,0l3.3,2c.4.2.4.6,0,.9l-3.3,1.9A1.4,1.4,0,0,1,105.4,124.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M111.3,127.5l-3.3-1.9c-.4-.3-.4-.7,0-.9l3.3-2a1.9,1.9,0,0,1,1.5,0l3.3,2c.4.2.4.6,0,.9l-3.3,1.9A1.4,1.4,0,0,1,111.3,127.5Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M121.4,133.4l-7.8-4.5a.6.6,0,0,1,0-.9l3.4-2a1.7,1.7,0,0,1,1.4,0l7.8,4.6a.4.4,0,0,1,0,.8l-3.3,2A1.9,1.9,0,0,1,121.4,133.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M46.5,90.3l-7.7-4.5q-.6-.5,0-.9l3.3-2a1.9,1.9,0,0,1,1.5,0l7.7,4.7c.4.2.4.6,0,.9L48,90.4A2.5,2.5,0,0,1,46.5,90.3Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M50.7,94.1l3.1,1.7c.5.3.5.7,0,1l-3,1.8a1.7,1.7,0,0,1-1.7,0L46,96.9c-.5-.2-.5-.7,0-1l3.1-1.7A1.1,1.1,0,0,1,50.7,94.1Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M56.6,97.4l3.1,1.7c.5.3.5.7,0,1l-3.1,1.7a1.7,1.7,0,0,1-1.7,0l-3.1-1.7c-.5-.3-.5-.7,0-1l3.1-1.7A2.5,2.5,0,0,1,56.6,97.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M60.8,105.4l-3.1-1.8c-.5-.2-.5-.7,0-.9l3.1-1.8a2.5,2.5,0,0,1,1.7,0l3.1,1.8c.5.2.5.7,0,.9l-3.1,1.8A2.5,2.5,0,0,1,60.8,105.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M66.7,108.8l-3.1-1.9c-.5-.2-.5-.7,0-.9l3.1-1.7a1.7,1.7,0,0,1,1.7,0l3.1,1.7c.5.2.5.7,0,.9l-3,1.9A2.8,2.8,0,0,1,66.7,108.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M72.6,112.1l-3.1-1.7c-.5-.3-.5-.8,0-1l3.1-1.7a1.7,1.7,0,0,1,1.7,0l3.1,1.7c.5.2.5.7,0,1l-3,1.7A1.5,1.5,0,0,1,72.6,112.1Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M78.5,115.5l-3.1-1.7c-.5-.2-.5-.7,0-1l3.1-1.7a2.5,2.5,0,0,1,1.7,0l3.1,1.7c.5.3.5.8,0,1l-3.1,1.7A1.7,1.7,0,0,1,78.5,115.5Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M84.4,118.9l-3.1-1.7c-.5-.2-.5-.7,0-.9l3.1-1.8a2.5,2.5,0,0,1,1.7,0l3.1,1.8c.5.2.5.7,0,.9l-3.1,1.7A1.7,1.7,0,0,1,84.4,118.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M90.3,122.4l-3.1-1.7c-.5-.3-.5-.8,0-1l3.1-1.7a1.7,1.7,0,0,1,1.7,0l3.1,1.7c.5.2.5.7,0,1L92,122.4A2.5,2.5,0,0,1,90.3,122.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M97.9,121.2l3.1,1.7c.5.2.5.7,0,.9l-3.1,1.8a2.5,2.5,0,0,1-1.7,0l-3.1-1.8c-.5-.2-.5-.7,0-.9l3.1-1.7A1.7,1.7,0,0,1,97.9,121.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M99,126.3l3.1-1.7a1.7,1.7,0,0,1,1.7,0l3.1,1.7c.5.2.5.7,0,1l-3.1,1.7a2.5,2.5,0,0,1-1.7,0L99,127.3C98.7,127,98.7,126.7,99,126.3Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M105.2,129.8l3-1.7a2.8,2.8,0,0,1,1.8,0l10.3,5.9c.5.3.5.7,0,1l-3.1,1.7a2.5,2.5,0,0,1-1.7,0l-10.3-5.9C104.7,130.6,104.7,130.1,105.2,129.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M37.7,86.5,48,92.4c.5.2.5.7,0,1l-3.1,1.7a2.5,2.5,0,0,1-1.7,0L32.9,89.3c-.5-.2-.5-.7,0-1L36,86.6A2,2,0,0,1,37.7,86.5Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M45.3,98.1l3.3,2a.4.4,0,0,1,0,.8l-3.3,2a1.4,1.4,0,0,1-1.5,0l-3.3-2a.4.4,0,0,1,0-.8l3.3-2A1.9,1.9,0,0,1,45.3,98.1Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M37.1,96.8l2.2,1.3a.6.6,0,0,1,0,.9l-.3.2a1.2,1.2,0,0,1-1.4,0l-2.3-1.3a.6.6,0,0,1,0-.9l.4-.2A1.2,1.2,0,0,1,37.1,96.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M32.8,94.3,35,95.7a.5.5,0,0,1,0,.8l-.4.3a2,2,0,0,1-1.5,0l-2.2-1.4a.4.4,0,0,1,0-.8l.4-.3A1.9,1.9,0,0,1,32.8,94.3Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M28.3,91.8l2.2,1.3q.6.5,0,.9l-.3.2a1.4,1.4,0,0,1-1.5,0l-2.2-1.3q-.6-.5,0-.9l.4-.2A1.2,1.2,0,0,1,28.3,91.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M35.6,92.7l2.2,1.4a.4.4,0,0,1,0,.8l-.4.3a1.7,1.7,0,0,1-1.4,0l-2.3-1.4a.5.5,0,0,1,0-.8l.4-.3A3.8,3.8,0,0,1,35.6,92.7Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M91.9,124.9l4.9,2.9a.4.4,0,0,1,0,.8l-3.3,2a1.9,1.9,0,0,1-1.5,0l-4.9-2.8q-.6-.5,0-.9l3.3-2A1.9,1.9,0,0,1,91.9,124.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M51,101.4l4.9,2.9a.5.5,0,0,1,0,.8l-3.4,1.8a1.2,1.2,0,0,1-1.4,0l-4.9-2.8a.4.4,0,0,1,0-.8l3.3-2A2.7,2.7,0,0,1,51,101.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M99.1,129.1l3.4,2a.5.5,0,0,1,0,.8l-3.4,2a1.7,1.7,0,0,1-1.4,0l-3.4-2a.5.5,0,0,1,0-.8l3.4-2A1.7,1.7,0,0,1,99.1,129.1Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M105,132.5l3.4,2a.6.6,0,0,1,0,.9l-3.4,1.9a1.2,1.2,0,0,1-1.4,0l-3.4-1.9a.6.6,0,0,1,0-.9l3.4-2A1.7,1.7,0,0,1,105,132.5Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M110.7,135.8l3.3,2c.4.2.4.6,0,.9l-3.3,1.9a1.4,1.4,0,0,1-1.5,0l-3.3-1.9c-.4-.3-.4-.7,0-.9l3.3-2A1.9,1.9,0,0,1,110.7,135.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M58.1,105.6l31.3,18c.4.2.4.6,0,.9l-3.3,1.9a1.4,1.4,0,0,1-1.5,0L53.3,108.3c-.4-.2-.4-.6,0-.9l3.3-1.9A2.5,2.5,0,0,1,58.1,105.6Z"
      transform="translate(-1 -0.7)"
    />
    <path class="cls-1" d="M136.9,130.8l5-2.9v-1l-5,2.8Z" transform="translate(-1 -0.7)" />
    <path class="cls-1" d="M129.5,135.2l5-2.9v-1.1l-5,2.9Z" transform="translate(-1 -0.7)" />
    <path
      class="cls-1"
      d="M266.7,157.8l-1.2-.8.3.3a3.3,3.3,0,0,1,1.3,2.5l-.3,3.3-2.4,35.1v.9l1.4.9,2.5-36,.3-3.2C268.8,159.7,267.8,158.4,266.7,157.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-5"
      d="M212.1,131.6v-10l-4.4-2.5c-.7-.4-1.2-.2-1.2.6v8.7h.3Z"
      transform="translate(-1 -0.7)"
    />
    <path class="cls-5" d="M264.4,199.4l-16.9-9.7,17,9.7v0Z" transform="translate(-1 -0.7)" />
    <path
      class="cls-2"
      d="M213.8,132.5V112l9-5.2L258.1,127v-1.6L212.1,99v32.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M223.1,117.7l-9.3-5.7v20.7l8.8,5,.8-.3-5.3-3v-1.1l6.7,3.8,3.7-.9h.6l-11-6.2v-1.1l32.6,18.7v.9l9.1,5.2v-9l-27-15.6v-9.8l27,15.6V128l-1.7-1-35.3-20.3Z"
      transform="translate(-1 -0.7)"
    />
    <path class="cls-6" d="M222.8,106.8v10.3l-9-5.1,9.3,5.7Z" transform="translate(-1 -0.7)" />
    <path class="cls-2" d="M222.8,106.8l-9,5.2,9,5.1Z" transform="translate(-1 -0.7)" />
    <path
      class="cls-1"
      d="M232.8,119.3v9.8l27,15.6,1.9,1.1V136l-1.9-1.1Zm17.4,17.2-2.3-1.4v-.5l1.8,1v-1.7l-1.6-1v-.5l1.6,1v-1.5l-1.7-1v-.4l2.2,1.3Zm2.9,1.7-2.4-1.4v-.5l1.7,1V133l.5.4v4.8Zm1.4.7-.5-.4v-4.7l.5.3Zm3.1,1.8-.5-.3v-2.2l-1.6-.9v-.5l1.6.9v-1.6l-1.7-1v-.5l2.2,1.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M218,128.9V130l11,6.2a2.4,2.4,0,0,1,1.2.4l20.4,11.7v-.7Z"
      transform="translate(-1 -0.7)"
    />
    <path class="cls-1" d="M218,134.4l5.4,3,1.4-.3-6.8-3.8Z" transform="translate(-1 -0.7)" />
    <path class="cls-5" d="M259.8,144.7v1.8l1.9-.9Z" transform="translate(-1 -0.7)" />
    <path
      class="cls-2"
      d="M255.4,135.1l1.6,1v1.6l-1.5-.9v.5l1.5.9v2.2l.6.3V136l-2.2-1.4Z"
      transform="translate(-1 -0.7)"
    />
    <path class="cls-2" d="M254,138.7l.5.2v-4.8l-.5-.2Z" transform="translate(-1 -0.7)" />
    <path
      class="cls-2"
      d="M252.6,137.3l-1.8-1.1v.6l2.3,1.4v-4.8l-.5-.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M247.9,130.9l1.7,1v1.5l-1.6-1v.6l1.6.9v1.7l-1.7-1v.5l2.3,1.4v-4.8l-2.3-1.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-5"
      d="M241.8,156.9v1.4l1.8,1.1V165l2.2,1.2c.3.1.5.4.7.6l.3.3h.2a3.9,3.9,0,0,1,2,3.1l-.2,3.1-1.1,16.2,16.8,9.7V198l2.5-35,.2-3.3a3.9,3.9,0,0,0-1.2-2.6l-.4-.2-.3-.2-5.5-3.1-9.1-5.3-20.4-11.7a1.7,1.7,0,0,0-1.2-.4h-.6l-3.7.9-1.3.2-.9.3-8.7-5.1-1.8-.9-5.2-3.1h-.3c-1-.5-1.8-.1-1.7.8l.4,6.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M248.6,173.6l.3-3.2a3.9,3.9,0,0,0-2-3.1h-.2a3.9,3.9,0,0,1,1,2.2l-.3,3.3-2.5,35v1.2l1.2.7,1.3-19.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-5"
      d="M189.6,139.4v-9.9l-1.3-.8c-.8-.3-1.3-.1-1.3.7l.2,4.2V138l.2.2Z"
      transform="translate(-1 -0.7)"
    />
    <path class="cls-5" d="M187.9,176l24.8,14.3Z" transform="translate(-1 -0.7)" />
    <path class="cls-5" d="M244.9,208.8h.2v-1.2Z" transform="translate(-1 -0.7)" />
    <path
      class="cls-2"
      d="M191.5,140.4v-11l50.3,28.9v-1.4l-36.4-20.8L189.6,127v12.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M243.6,159.4l-1.8-1.1-50.3-28.9v11l11.5,6.7,5.9-1.3a2.8,2.8,0,0,1,1.9.3L243.5,165v-5.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-5"
      d="M245.1,207.6l2.4-35,.3-3.3a3.2,3.2,0,0,0-1-2.2c-.1-.2-.1-.3-.3-.3l-.7-.6-2.2-1.2-32.7-18.9a2.5,2.5,0,0,0-1.9-.3l-5.9,1.3-11.5-6.7-1.9-1.1-2.2-1.3h-.2c-1-.5-1.9-.1-1.7.9l2.3,36.6v.5h.1l24.9,14.3,32.2,18.5Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M121.9,77.9l-1.2-.7.3.2a3.6,3.6,0,0,1,1.3,2.6l-.3,3.3-2.4,35v1l1.4.9,2.5-36,.2-3.2A3.4,3.4,0,0,0,121.9,77.9Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-5"
      d="M67.3,51.7V41.8l-4.4-2.6c-.8-.3-1.3-.1-1.3.6l.2,4.3v4.4c.1,0,.1.2.2.2Z"
      transform="translate(-1 -0.7)"
    />
    <path class="cls-7" d="M119.6,119.6l-16.9-9.7,16.9,9.7v0Z" transform="translate(-1 -0.7)" />
    <path class="cls-8" d="M119.6,119.6l-16.9-9.7Zm0,0v0Z" transform="translate(-1 -0.7)" />
    <path
      class="cls-2"
      d="M69,52.8V32.1L77.9,27l35.3,20.2V45.6L67.3,19.2V51.7Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M78.2,37.9,69,32.1V52.8l8.8,5,.8-.2-5.4-3.1V53.4l6.6,3.8,3.7-.8h.6L73.2,50.1V49l32.6,18.8v.8l9.1,5.3V64.8L87.8,49.3V39.5L114.9,55V48.3l-1.7-1.1L77.9,27Z"
      transform="translate(-1 -0.7)"
    />
    <path class="cls-6" d="M77.9,27V37.3L69,32.1l9.2,5.8Z" transform="translate(-1 -0.7)" />
    <path class="cls-2" d="M77.9,27,69,32.1l8.9,5.2Z" transform="translate(-1 -0.7)" />
    <path
      class="cls-1"
      d="M88,39.5v9.8l27,15.5,1.8,1.1V56.1L115,55Zm17.3,17.1L103,55.3v-.5l1.8,1V54.1l-1.6-1v-.5l1.6,1V52.1l-1.7-1v-.5l2.2,1.4Zm2.9,1.7L105.9,57v-.5l1.7,1V53.2l.5.4v4.7Zm1.5.9-.5-.4V54.1l.5.3Zm3,1.7-.5-.4V58.3l-1.6-.8V57l1.6.8V56.3l-1.7-1v-.5l2.2,1.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M73.2,49v1.1l10.9,6.3,1.3.3,20.4,11.8v-.9Z"
      transform="translate(-1 -0.7)"
    />
    <path class="cls-1" d="M73.2,54.5l5.3,3.1,1.3-.4-6.6-3.8Z" transform="translate(-1 -0.7)" />
    <path class="cls-5" d="M114.9,64.8v1.9l1.8-.9Z" transform="translate(-1 -0.7)" />
    <path
      class="cls-2"
      d="M110.5,55.3l1.7,1v1.5l-1.6-.8v.5l1.6.8v2.2l.5.4V56.1l-2.2-1.3Z"
      transform="translate(-1 -0.7)"
    />
    <path class="cls-2" d="M109.2,58.8l.5.4V54.4l-.5-.3Z" transform="translate(-1 -0.7)" />
    <path
      class="cls-2"
      d="M107.7,57.5l-1.8-1V57l2.3,1.3V53.6l-.5-.4Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M103.1,51.1l1.7,1v1.5l-1.6-1v.6l1.6.9v1.7l-1.8-1v.5l2.3,1.3V51.8l-2.2-1.3Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-5"
      d="M96.8,77.2v1.3l1.9,1.1v5.6l2.2,1.2a1.9,1.9,0,0,1,.7.6l.2.2.3.2a3.8,3.8,0,0,1,2,3l-.3,3.3-1.1,16.2,16.9,9.7v-1.3l2.4-35,.3-3.3a3.6,3.6,0,0,0-1.3-2.6l-.3-.2-.4-.2L115,73.9l-9.1-5.3L85.5,56.9a2.1,2.1,0,0,0-1.2-.4h-.6l-3.7.9-1.4.2-.8.2-8.8-5-1.7-1.1-5.3-3c-.1,0-.1-.2-.2-.2s-1.9-.1-1.8.9l.4,6.7Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-1"
      d="M103.8,93.7l.3-3.2a3.9,3.9,0,0,0-2-3h-.3a3.2,3.2,0,0,1,1,2.2l-.2,3.3-2.5,35v1.2l1.1.6,1.4-19.8Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-5"
      d="M44.8,59.6v-10l-1.3-.7c-.8-.4-1.3-.1-1.3.6v4.3l.2,4.4h.2Z"
      transform="translate(-1 -0.7)"
    />
    <path class="cls-5" d="M43.1,96.2,68.7,111Z" transform="translate(-1 -0.7)" />
    <path class="cls-7" d="M100.1,129h0v0Z" transform="translate(-1 -0.7)" />
    <path class="cls-8" d="M100.1,129h0Zm0,0v0Z" transform="translate(-1 -0.7)" />
    <path
      class="cls-2"
      d="M46.6,60.5v-11L96.8,78.4V77.2L60.4,56.3,44.8,47.2V59.6Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-2"
      d="M98.7,79.5l-1.9-1.1L46.6,49.5v11l11.6,6.8,5.9-1.4a2.6,2.6,0,0,1,1.8.4L98.7,85.2Z"
      transform="translate(-1 -0.7)"
    />
    <path
      class="cls-5"
      d="M100.2,127.8l2.5-35.1.3-3.3a3.4,3.4,0,0,0-1-2.2l-.3-.2c-.2-.3-.5-.4-.7-.6l-2.2-1.2L65.9,66.3a2.4,2.4,0,0,0-1.8-.4l-5.9,1.4L46.6,60.5l-1.8-1.1-2.2-1.2h-.3c-.9-.5-1.8-.1-1.7.9L43,95.6v.5h.1l25.6,14.6,31.4,18.2Z"
      transform="translate(-1 -0.7)"
    />
    <g id="paper5">
      <path
        class="cls-2"
        d="M239.9,111.2l17.6,25.9-21.3,19.2-21.9-32.1,18-16.3,4.3,6.3Z"
        transform="translate(-1 -0.7)"
      />
      <path class="cls-2" d="M232.3,107.9l4.3,6.3,3.3-3Z" transform="translate(-1 -0.7)" />
      <path
        class="cls-1"
        d="M231.9,114.4l15.6,22.8.3-.3-15.5-22.7Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-1"
        d="M230.6,115.8,247.2,140l.3-.2-16.6-24.4Z"
        transform="translate(-1 -0.7)"
      />
      <path class="cls-1" d="M229.2,117l16.5,24.4.4-.4-16.6-24.4Z" transform="translate(-1 -0.7)" />
      <path
        class="cls-1"
        d="M227.7,118.2l16.6,24.4.4-.3L228.1,118Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-1"
        d="M226.4,119.6,243,143.9l.2-.3-16.4-24.4Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-1"
        d="M224.9,120.8l16.6,24.4.4-.4-16.6-24.3Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-1"
        d="M223.6,122.1l16.6,24.3.2-.3-16.5-24.3Z"
        transform="translate(-1 -0.7)"
      />
    </g>
    <g id="paper4">
      <path
        class="cls-2"
        d="M206.6,57.4l24.8,28.9-19.8,33L180.8,83.4l16.8-27.9,5.9,7Z"
        transform="translate(-1 -0.7)"
      />
      <path class="cls-6" d="M197.6,55.5l6,7.5,3-5.6Z" transform="translate(-1 -0.7)" />
      <path class="cls-2" d="M197.6,55.5l5.9,7,3.1-5.1Z" transform="translate(-1 -0.7)" />
      <path
        class="cls-1"
        d="M198.5,64.3l21.9,25.5.3-.5L198.8,63.8Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-1"
        d="M197.2,66.5l23.4,27.3.4-.6L197.5,66.1Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-1"
        d="M195.9,68.7l23.4,27.2.3-.5L196.3,68.1Z"
        transform="translate(-1 -0.7)"
      />
      <path class="cls-1" d="M194.5,71,218,98.1l.3-.5L194.9,70.3Z" transform="translate(-1 -0.7)" />
      <path
        class="cls-1"
        d="M193.3,73.2l23.4,27.1.3-.5L193.6,72.5Z"
        transform="translate(-1 -0.7)"
      />
      <path class="cls-1" d="M192,75.2l23.3,27.3.4-.4L192.3,74.7Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M190.6,77.4l23.5,27.3.2-.6L191,77Z" transform="translate(-1 -0.7)" />
    </g>
    <g id="paper3">
      <path
        class="cls-2"
        d="M145.1,12.1l33.3,19.1V90.8L137.1,67V16.7l8,4.7Z"
        transform="translate(-1 -0.7)"
      />
      <path class="cls-1" d="M142,27.7l29.4,16.9v-1L142,26.7Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M142,31.6l31.4,18.2v-1L142,30.7Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M142,35.7l31.4,18v-1L142,34.6Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M142,39.6l31.4,18v-1L142,38.6Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M142,43.5l31.4,18v-1L142,42.5Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M142,47.4l31.4,18.2v-1L142,46.5Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M142,51.4l31.4,18.1v-1L142,50.4Z" transform="translate(-1 -0.7)" />
      <path class="cls-2" d="M137.1,16.7l8,4.7V12.1Z" transform="translate(-1 -0.7)" />
    </g>
    <g id="paper2">
      <path
        class="cls-2"
        d="M89.3,3.6l24.2-1.7,21.4,55.7-30.2,2.2-18-47,5.9-.5Z"
        transform="translate(-1 -0.7)"
      />
      <path class="cls-2" d="M86.7,12.8l5.9-.5L89.3,3.6Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M93.2,20.1l21.4-1.6-.2-.8L92.9,19.3Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M94.7,23.8l22.9-1.6-.4-1L94.3,23Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M96.1,27.5l22.8-1.6-.2-1-23,1.7Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M97.5,31.3l22.9-1.7-.4-1L97.2,30.3Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M98.9,35l22.9-1.8-.4-.8L98.5,34Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M100.2,38.6l23-1.7-.3-.8L100,37.6Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M101.7,42.3l22.9-1.7-.4-.9-22.8,1.6Z" transform="translate(-1 -0.7)" />
    </g>
    <g id="paper1">
      <path
        class="cls-2"
        d="M61.3,27.7,76,17.2l26,41.4L83.5,71.8l-21.9-35,3.6-2.6Z"
        transform="translate(-1 -0.7)"
      />
      <path class="cls-2" d="M61.6,36.8l3.6-2.6-3.9-6.5Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M67.4,41l13.1-9.4-.4-.7-13,9.3Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M69.1,43.6l14.1-9.9-.5-.7L68.8,43Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M70.9,46.5l14-10.1-.5-.6-14,9.9Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M72.6,49.2l14-10-.5-.7-14,9.9Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M74.3,51.8l13.9-9.9-.4-.7-14,10Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M76,54.7,89.9,44.6l-.3-.6L75.5,53.9Z" transform="translate(-1 -0.7)" />
      <path class="cls-1" d="M77.8,57.4l13.8-10-.3-.7-14,9.9Z" transform="translate(-1 -0.7)" />
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig", "isAnimationDisabled", "viewportSize"]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    bookAnim() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-drop",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
          defaults: {
            duration: 0.75,
            ease: "sine",
            repeat: 2,
            yoyo: true,
            repeatDelay: 0.25,
          },
        })
        .add("drop")
        .fromTo(
          "#paper1",
          {
            opacity: 0,
          },
          {
            opacity: 1,
          },
          "drop"
        )
        .fromTo(
          "#paper2",
          {
            opacity: 0,
          },
          {
            opacity: 1,
          },
          "drop+=0.25"
        )
        .fromTo(
          "#paper3",
          {
            opacity: 0,
          },
          {
            opacity: 1,
          },
          "drop+=0.5"
        )
        .fromTo(
          "#paper4",
          {
            opacity: 0,
          },
          {
            opacity: 1,
          },
          "drop+=0.75"
        )
        .fromTo(
          "#paper5",
          {
            opacity: 0,
          },
          {
            opacity: 1,
          },
          "drop+=1"
        );
    },
  },
  mounted() {
    this.bookAnim();
  },
};
</script>

<style lang="scss" scoped>
.cls-1,
.cls-3,
.cls-4,
.cls-6 {
  fill: #0e1e25;
}

.cls-1,
.cls-2,
.cls-3,
.cls-4,
.cls-5,
.cls-6,
.cls-8 {
  stroke: #0e1e25;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.cls-2 {
  fill: #fff;
}

.cls-3 {
  stroke-width: 0.15px;
}

.cls-4 {
  opacity: 0.02;
}

.cls-4,
.cls-6 {
  isolation: isolate;
}

.cls-5,
.cls-7 {
  fill: #ffad43;
}

.cls-6 {
  opacity: 0.2;
}

.cls-8 {
  fill: none;
}
</style>
